import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form-acj-edit',
  templateUrl: './form-acj-edit.component.html',
  styleUrls: ['./form-acj-edit.component.scss']
})
export class FormAcjEditComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
